import { IS_NOT_FOUND_UPDATED } from '@gig/magic-messages';

var PageNotFoundService = /** @class */ (function () {
    function PageNotFoundService() {
        this.isNotFound = false;
        this.registerEvents();
        this.subscribeToEvents();
        this.initializeValues();
    }
    PageNotFoundService.prototype.registerEvents = function () {
        window.eventBus.register(IS_NOT_FOUND_UPDATED, {
            type: 'boolean',
        });
    };
    PageNotFoundService.prototype.subscribeToEvents = function () {
        var _this = this;
        window.eventBus.subscribe(IS_NOT_FOUND_UPDATED, function (e) {
            var _a;
            _this.isNotFound = (_a = e.payload) !== null && _a !== void 0 ? _a : false;
        }, { replay: true });
    };
    PageNotFoundService.prototype.initializeValues = function () {
        window.eventBus.publish(IS_NOT_FOUND_UPDATED, false);
    };
    return PageNotFoundService;
}());

export { PageNotFoundService };
